import script from "./Main.vue?vue&type=script&setup=true&lang=ts"
export * from "./Main.vue?vue&type=script&setup=true&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=574fe6b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-574fe6b8"]])

export default __exports__